__turbopack_context__.v({
  "container": "Container-module-scss-module__69tsbq__container",
  "full": "Container-module-scss-module__69tsbq__full",
  "lg": "Container-module-scss-module__69tsbq__lg",
  "md": "Container-module-scss-module__69tsbq__md",
  "sm": "Container-module-scss-module__69tsbq__sm",
  "xl": "Container-module-scss-module__69tsbq__xl",
});
